(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class PdpMobileStickyBar extends HTMLElement {
    #section;
    #mobileMediaQuery;
    #sizeFieldset = null;
    #sizePanel = null;
    #sizePanelClone = null;
    #sizeScrim = null;

    connectedCallback() {
      this.#section = this.closest('.product-information');
      if (!this.#section) return;

      this.#mobileMediaQuery = window.matchMedia('(max-width: 1023px)');
      this.#sizePanel = this.querySelector('[data-pdp-mobile-size-panel]');
      this.#sizeScrim = this.querySelector('[data-pdp-mobile-size-scrim]');
      this.#sizeFieldset = this.#getInFlowSizeFieldset();

      this.#mobileMediaQuery.addEventListener('change', this.#handleBreakpointChange);
      this.addEventListener('click', this.#handleClick);
      this.#section.addEventListener('variant:update', this.#handleVariantUpdate);
      this.#syncSizePanelClone();
      this.#syncChooseSizeButtonState();
    }

    disconnectedCallback() {
      this.#mobileMediaQuery?.removeEventListener('change', this.#handleBreakpointChange);
      this.removeEventListener('click', this.#handleClick);
      this.#section?.removeEventListener('variant:update', this.#handleVariantUpdate);
      this.#clearSizePanelClone();
    }

    #handleClick(event) {
      if (!this.#isMobileLayout()) return;
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('[data-pdp-mobile-size-scrim]')) {
        event.preventDefault();
        this.#closeSizePanel();
        return;
      }

      const addToCartButton = event.target.closest('[ref="addToCartButton"]');
      if (addToCartButton && !addToCartButton.hasAttribute('data-open-size-panel') && this.#isSizePanelOpen()) {
        this.#closeSizePanel();
        return;
      }

      if (!event.target.closest('[data-open-size-panel]')) return;

      event.preventDefault();
      this.#openSizePanel();
    }

    #handleVariantUpdate() {
      this.#syncChooseSizeButtonState();

      if (!this.#isMobileLayout()) return;
      if (this.dataset.requiresSizeSelection !== 'true') return;

      this.#sizeFieldset = this.#getInFlowSizeFieldset();

      if (this.#isSizePanelOpen()) {
        const fieldset = this.#getInFlowSizeFieldset();
        if (fieldset && this.#sizePanelClone?.isConnected) {
          this.#syncCloneCheckedState(fieldset, this.#sizePanelClone);
        } else {
          this.#syncSizePanelClone();
        }
      }
    }

    restoreOpenSizePanel() {
      if (!this.#isMobileLayout() || this.dataset.requiresSizeSelection !== 'true') return;

      this.#section = this.closest('.product-information');
      this.#sizePanel = this.querySelector('[data-pdp-mobile-size-panel]');
      this.#sizeScrim = this.querySelector('[data-pdp-mobile-size-scrim]');
      this.#sizeFieldset = this.#getInFlowSizeFieldset();

      this.dataset.sizePanelOpen = 'true';
      this.#sizePanel?.setAttribute('aria-hidden', 'false');
      this.#clearSizePanelClone();
      this.#syncSizePanelClone();
      this.#syncChooseSizeButtonState();
    }

    #openSizePanel() {
      this.dataset.sizePanelOpen = 'true';
      this.#sizePanel?.setAttribute('aria-hidden', 'false');
      this.#syncSizePanelClone();
    }

    #closeSizePanel() {
      if (!this.#isSizePanelOpen()) return;

      this.dataset.sizePanelOpen = 'false';
      this.#sizePanel?.setAttribute('aria-hidden', 'true');
      this.#clearSizePanelClone();
    }

    #handleBreakpointChange() {
      if (!this.#isMobileLayout()) {
        this.#closeSizePanel();
      } else if (this.#isSizePanelOpen()) {
        this.#syncSizePanelClone();
      }

      this.#syncChooseSizeButtonState();
    }

    #isMobileLayout() {
      return this.#mobileMediaQuery?.matches ?? false;
    }

    #isSizePanelOpen() {
      return this.dataset.sizePanelOpen === 'true';
    }

    #syncChooseSizeButtonState() {
      const button = this.querySelector('[data-open-size-panel]');
      if (!button) return;

      button.disabled = !this.#isMobileLayout();
    }

    #getInFlowSizeFieldset() {
      return this.#section?.querySelector(
        '.variant-picker .variant-option--size:not([data-pdp-mobile-size-panel-clone])'
      );
    }

    #clearSizePanelClone() {
      this.#sizePanelClone?.remove();
      this.#sizePanelClone = null;
    }

    #syncSizePanelClone() {
      const panel = this.#sizePanel;
      if (!panel) return;

      if (!this.#isMobileLayout() || !this.#isSizePanelOpen() || this.dataset.requiresSizeSelection !== 'true') {
        this.#clearSizePanelClone();
        return;
      }

      const fieldset = this.#getInFlowSizeFieldset();
      if (!fieldset) {
        this.#clearSizePanelClone();
        return;
      }

      if (this.#sizePanelClone && this.#sizePanelClone.dataset.sourceFieldset === fieldset.dataset.fieldsetIndex) {
        this.#syncCloneCheckedState(fieldset, this.#sizePanelClone);
        return;
      }

      this.#clearSizePanelClone();

      const clone = fieldset.cloneNode(true);
      clone.setAttribute('data-pdp-mobile-size-panel-clone', '');
      clone.dataset.sourceFieldset = fieldset.dataset.fieldsetIndex ?? '';
      clone.removeAttribute('ref');

      clone.querySelectorAll('[id]').forEach((element) => {
        element.removeAttribute('id');
      });

      clone.querySelectorAll('.variant-option__size-status--few_left').forEach((element) => {
        element.remove();
      });

      clone.querySelectorAll('input[type="radio"]').forEach((input) => {
        const original = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(input.value)}"]`);
        input.disabled = true;
        input.checked = original?.checked ?? false;
      });

      clone.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const label = event.target.closest('label');
        if (!label || !clone.contains(label)) return;

        const value = label.querySelector('input[type="radio"]')?.value;
        if (!value) return;

        event.preventDefault();
        event.stopPropagation();
        const original = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
        original?.click();
      });

      panel.appendChild(clone);
      this.#sizePanelClone = clone;
    }

    #syncCloneCheckedState(fieldset, clone) {
      fieldset.querySelectorAll('input[type="radio"]').forEach((original) => {
        const cloneInput = clone.querySelector(`input[type="radio"][value="${CSS.escape(original.value)}"]`);
        if (cloneInput) {
          cloneInput.checked = original.checked;
        }
      });
    }
  }

  if (!customElements.get('pdp-mobile-sticky-bar')) {
    customElements.define('pdp-mobile-sticky-bar', PdpMobileStickyBar);
  }
  } catch(e) { console.error(e); }
})();

})();
